export const enum InviteStatuses {
  Wait = 'Wait',
  Sent = 'Sent',
  Accepted = 'Accepted',
  Expired = 'Expired',
}
